<template>

  <div class="home">

      <!-- 首页顶部的 -->
    <div class="topNr"   
    :class="[ $route.path==='/'? 'hometabdw':'']"
    
    >
      <!-- 顶部的容器  width 80% -->
        <div class="dbtop">
          <!-- 顶部  左边的 logo -->
        <div class="dbtopleft" @click="$router.push('/')">
           <img src="@/assets/home/logo.svg" alt="">
        </div>
        <!-- 顶部 中间的 active切换蓝 -->
        <div class="dbtopcenter">
            <div class="toptabitem"
            v-for="(item,index) in topactive"
            :key="index"
            @click="gotoactive(item,index)"
            >
              <div class="txt">{{item.name}}</div>
              <div class="xhx" v-if="$store.getters.istopactive===item.id"></div>
            </div>
        </div>

        <!-- 顶部 右侧的开通会员 登录 及 头像 -->
        <div class="dbtopright">
         <div class="vip" @click="gotovippop" v-if="isuserInfo.isVip">
           <img class="vipbg" src="@/assets/components/home/xufeivip.svg" alt="">
         </div>

          <div class="vip" @click="gotovippop" v-else>
            <!-- <img
              class="vipicon"
              src="@/assets/components/home/vipicon.png"
              alt=""
            /> -->
            <img class="vipbg" src="@/assets/components/home/vip.svg" alt="" />
          </div>
          <div class="login" @click="loginbtn" v-if="!isuserInfo.isSign">
            <img src="@/assets/components/home/loginbtn.svg" alt="">
          </div>
          <div
            class="tx"
            v-else
            @click="$store.commit('updatetouxiangcard', true)"
          >
            <el-avatar :size="42" :src="isuserInfo?.avatar">
              <img src="@/assets/components/morentx.png" />
            </el-avatar>
            <div style="font-size: 14px; margin-left: 10px;white-space: nowrap;color:#fff">
              {{ isuserInfo?.username }}
            </div>
          </div>
        </div>
        </div>
    </div>

<!-- 首页的内容 -->


  <div class="homeCenterNr"
  >
     <router-view></router-view>
  </div>
  

<bottom></bottom>

  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import bottom from "@/components/bottom.vue";
import { mapGetters, mapMutations } from "vuex";
import assist from "@/utils/commonality";
export default {
  mixins: [],
  components: {
    bottom,
  },
  props: {},
  data() {
    return {
      topactive:[
        {
          id:1,
          name:'首页',
          path:'/'
        },
        {
          id:2,
          name:'录屏',
          path:'/transcribe'
        },
                {
          id:3,
          name:'图片编辑',
          path:'/imgedit'
        },
                {
          id:4,
          name:'拼图',
          path:'/spellimage'
        },
         {
          id:5,
          name:'关于我们',
          path:'/about'
        },
      ],


    };
  },
  computed: {
    ...mapGetters(["isuserInfo", "isconfigforChannel"]),
  },
  watch: {
  },
  created() {
    
  },
  mounted() {

   // 每次进首页 判断有没有uid
    let islogin = this.$store.getters.isuid;
    if (islogin && islogin !==1) {  
      //这里是用户手机号登录的
      // 如果已经有uid 就判断用户是否登录
      if (!this.$store.state.userInfo.isSign) {
        //如果没有登录 就发起请求获取用户信息
        this.$store.dispatch("getuserinfo");
        this.qiangouPop = true
      }else {
         console.log('刷新用户信息');
        this.$store.dispatch("getuserinfo");
      }
    } else {
      //这里是用户即没有扫码  也没有手机号登录 不做任何处理
    }

    (function (w, d, t, r, u) {
      //必应
      var f, n, i;
      (w[u] = w[u] || []),
        (f = function () {
          //根据渠道id做判断获取 ti
          // var o = { ti: "34313204", enableAutoSpaTracking: true };
          var o = { ti: assist.getRequest("e"), enableAutoSpaTracking: true };
          (o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
        }),
        (n = d.createElement(t)),
        (n.src = r),
        (n.async = 1),
        (n.onload = n.onreadystatechange =
          function () {
            var s = this.readyState;
            (s && s !== "loaded" && s !== "complete") ||
              (f(), (n.onload = n.onreadystatechange = null));
          }),
        (i = d.getElementsByTagName(t)[0]),
        i.parentNode.insertBefore(n, i);
    })(window, document, "script", "//bat.bing.com/bat.js", "uetq");

    this.$store.dispatch("getconfigforChannel");
  },
  methods: {
  
    ...mapMutations(["updatispopvip", "updatetabactive", "updateloginVisible"]),

    gotovippop() {
      if (this.$store.getters.isuserInfo.isSign) {
        //如果已经登录了
        this.updatispopvip(true);
      } else {
        this.updateloginVisible(true);
      }
    },
    loginbtn() {
      //登录按钮
      this.$store.commit("updateloginVisible", true);
    },
    // 分开 上面是固定的
    gotoactive(item) { //top跳转
       assist.manage({position: `点击顶部导航栏：${item.name}`})//埋点全局登录
     //由路由控制 active的切换
     this.$router.push(item.path)
    }, 


  },
};
</script> 

<style scoped lang="scss">
.home {
  
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1300px;
  .topNr {
    position: relative;
    width: 100%;
    background-color: #262827;

    .dbtop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 80%;
      margin: 0 auto;
      height: 60px;
      .dbtopleft {
        cursor: pointer;
        img {
          width: 150px;
          margin-top:3px ;
        }
      }


      .dbtopcenter {
        display: flex;
        align-items: center;
        height: 100%;
        width: 50%;
        margin-left: 6%;
        .toptabitem {
          color: #fff;
         position: relative;
          cursor: pointer;
          margin-right: 10%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .txt {
            margin-bottom: 5px;
            white-space: nowrap;
          }

          .xhx {
            position: absolute;
            bottom: 20%;
            width: 50%;
            height: 4px ;
            margin: 0 auto 0;
            background: linear-gradient( 224deg, #FDBF5C 0%, #F34E2D 53%, #FF356E 100%);
            border-radius:8px;
          }
        }
    
      }



 

      .dbtopright {
        display: flex;
        align-items: center;
        color: #fff;
        .login {
          cursor: pointer;
          margin-left: 25px;
          display: flex;
          align-items: center;
          justify-content: center;

           img {
            height: 2.3em;
          }
        }
        .tx {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 15px;
         
        }
          .vip {
    cursor: pointer;
    position: relative;
    // width: 93px;
    height: 2.3em;
    .vipicon {
      width: 20;
      height: 18px;
      position: absolute;
      top: 19%;
      left: 9%;
    }
    .vipbg {
      width: 100%;
      height: 100%;
    }
  }
      }
    }





  }


  .homeCenterNr {
    width: 100%;
  }
}


  .hometabdw {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    z-index: 10;
    background-color: rgba(255,255,255,0.1) !important;
  }

</style>